module.exports = __webpack_public_path__ + "media/images/athletes/3583-b2a0f7e7bb5ee852c40f1dbb3b5a4e1d.png";